// 共通：最終ログインなどの相対表示を日本語で行う
// 仕様：
// - 1分未満: 「たった今」
// - 1〜9分: 「X分前」
// - 10〜59分: 10の位で丸め「10分前」「20分前」…
// - 1〜23時間: 「X時間前」 (切り捨て)
// - 1〜29日: 「X日前」 (切り捨て)
// - 1〜11ヵ月: 「Xヵ月前」(30日=1ヵ月換算, 切り捨て)
// - 1年以上: 「X年前」(365日=1年換算, 切り捨て)

export const ONLINE_WINDOW_MS = 5 * 60 * 1000;

export function resolvePresenceTimestamp(input = {}) {
    if (!input || typeof input !== "object") return null;
    return input.last_active_at || input.lastActiveAt || input.last_login_at || input.lastLoginAt || null;
  }

export function isOnlineRecently(input, nowTs = Date.now(), windowMs = ONLINE_WINDOW_MS) {
    if (!input) return false;
    const ts = (input instanceof Date)
      ? input.getTime()
      : typeof input === "number"
        ? input
        : new Date(input).getTime();
    if (Number.isNaN(ts)) return false;
    return Math.max(0, nowTs - ts) <= Math.max(60_000, Number(windowMs) || ONLINE_WINDOW_MS);
  }

export function formatRelativeTime(input, nowTs = Date.now()) {
    if (!input) return "-";
  
    const ts = (input instanceof Date)
      ? input.getTime()
      : typeof input === "number"
        ? input
        : new Date(input).getTime();
  
    if (Number.isNaN(ts)) return "-";
  
    let diffMs = Math.max(0, nowTs - ts); // 未来は0扱い
    const sec = Math.floor(diffMs / 1000);
    if (sec < 60) return "たった今";
  
    const min = Math.floor(sec / 60);
    if (min < 10) return `${min}分前`;
    if (min < 60) return `${Math.floor(min / 10) * 10}分前`;
  
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}時間前`;
  
    const day = Math.floor(hr / 24);
    if (day < 30) return `${day}日前`;
  
    const month = Math.floor(day / 30); // 30日=1ヵ月換算
    if (month < 12) return `${month}ヵ月前`;
  
    const year = Math.floor(day / 365); // 365日=1年換算
    return `${year}年前`;
  }
  
